import { render, staticRenderFns } from "./RegisterPackage.vue?vue&type=template&id=345ca78c&scoped=true"
import script from "./RegisterPackage.vue?vue&type=script&lang=js"
export * from "./RegisterPackage.vue?vue&type=script&lang=js"
import style0 from "./RegisterPackage.vue?vue&type=style&index=0&id=345ca78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345ca78c",
  null
  
)

export default component.exports